// List of all API routes
export const seatersAdminPrefix = 'seaters-admin';
export const V2Prefix = 'v2';

export const endpoints = {
  accept: 'accept',
  acceptSeats: 'accept-seats',
  resendRSVP: 'resend-rsvp',
  additionalInfos: 'additional-infos',
  addTickets: 'add-tickets',
  advancedSearch: 'advanced-search',
  aggregateInvitations: 'aggregate-invitations',
  answers: 'answers',
  answerSemantics: 'answer-semantics',
  app: 'app',
  activate: 'activate',
  activation: 'activation',
  approve: 'approve',
  archive: 'archive',
  approver: 'approver',
  approverRequests: 'approver-requests',
  approvers: 'approvers',
  assign: 'assign',
  assignWithoutSeats: 'assign-without-seats',
  assignWithParking: 'assign-with-parking',
  attendees: 'attendees',
  attendeesInfo: 'attendees-info',
  auth: 'auth',
  authentication: 'authentication',
  availableSeats: 'available-seats',
  availableSecondarySeats: 'available-secondary-tickets',
  backgroundImage: 'background-image',
  badges: 'badges',
  badgesCodeProtection: 'badges-code-protection',
  // Smart Invites tender blackouts (compliance/fan-groups/:id/blackouts).
  blackouts: 'blackouts',
  barCodes: `${seatersAdminPrefix}/available-barcode-types`,
  cancel: 'cancel',
  categories: 'categories',
  category: 'category',
  checkTransaction: 'check-transaction',
  choices: 'choices',
  close: 'close',
  configs: 'configs',
  configuration: 'configuration',
  communicationcampaigns: 'communicationcampaigns',
  files: 'files',
  attachmentUrl: 'attachment-url',
  wishlists: 'wishlists',
  internalNotes: 'internal-notes',
  ticketLimits: 'ticket-limits',
  experienceGroups: 'experience-groups',
  experienceCards: 'experience-cards',
  days: 'days',
  usage: 'usage',
  recommendations: 'recommendations',
  companies: 'companies',
  countries: 'app/countries',
  code: 'code',
  countSeats: 'count-seats',
  coverImage: 'cover-image',
  currencyCodes: 'app/currencies',
  customInfo: 'custom-info',
  customInfoCodeProtection: 'custom-info-code-protection',
  declineSeatsRequest: 'decline-seats-request',
  details: 'details',
  dislike: 'dislike',
  distribution: 'distribution',
  distributionFinished: 'distribution-finished',
  draft: 'draft',
  dropOff: 'drop-off',
  email: 'email',
  // Smart Invites Guest Employer directory (compliance/fan-groups/:id/employers).
  employers: 'employers',
  completion: 'completion',
  estimatedTickets: 'estimated-tickets',
  // Smart Invites path segment for a fan group's experience catalogue: the Host catalogue route
  // spells it `host/fan-groups/:fanGroupId/experiences`, never `waiting-lists`.
  experiences: 'experiences',
  events: `events`,
  expiredPositions: 'expired-positions',
  exportGeneratedTicketPoolCodes: 'export-codes',
  exportParkingTicket: 'export-parking-ticket',
  exportSeat: 'export-seat',
  exportSeats: 'export-seats',
  exportPositions: 'export-positions',
  exportSurveyAnswerReport: 'export-survey-answer-report',
  facets: 'facets',
  fan: 'fan',
  fanShortSession: 'fan-short-session',
  fanAttributes: 'fan-attributes',
  fanGroupHost: 'fangroup-host',
  fanGroupOwner: 'fan-group-owner',
  fanGroupApprover: 'fangroup-approver',
  fanGroupProtectionCodes: 'protection-codes',
  wishListProtectionCodes: 'protection-codes',
  fanGroupProtectionCodesEnhanced: 'enhanced-protection-codes',
  fanGroups: `fan-groups`,
  fanGroupsBySlug: 'fangroups-by-slug',
  fgoInsights: 'fgo/insights',
  fgoPreferences: 'fgo/preferences',
  dashboardActivity: 'dashboard/activity',
  dashboardExperienceRequestTrends: 'dashboard/experience-request-trends',
  dashboardHistory: 'dashboard/history',
  dashboardJourney: 'dashboard/journey',
  dashboardMetrics: 'dashboard/metrics',
  dashboardStatistics: 'dashboard/statistics',
  dashboardSurvey: 'dashboard/survey',
  fanSurveys: 'fgo/fans',
  crmLead: 'fgo/crm/lead',
  filters: 'filters',
  generatedTicketPools: 'generated-ticket-pools',
  generatedTicketPreview: 'preview',
  generationProgress: 'generation-progress',
  giveSeats: 'give-seats',
  giveParking: 'give-parking',
  giveSeatsParking: 'give-seats-parking',
  giveTicketsAfterVoucher: 'give-tickets-after-voucher',
  grant: 'grant',
  groups: 'groups',
  guest: 'guest',
  guests: 'guests',
  guestsMy: 'my-guests',
  host: 'host',
  hosts: 'hosts',
  instances: 'instances',
  interests: 'interests',
  invitations: 'invitations',
  joinedGroups: 'joined-groups',
  joinedWaitingLists: 'joined-waiting-lists',
  languages: 'app/languages',
  like: 'like',
  link: 'link',
  linkByName: 'link-by-name',
  loginConfigurations: 'login-configurations',
  login_v2: 'v2/authentication/login',
  login: 'auth/verify',
  logoImage: 'logo-image',
  look: 'look',
  markForDistribution: 'mark-for-distribution',
  markForParkingDistribution: 'mark-for-parking-distribution',
  members: 'members',
  memberSegments: 'member-segments',
  moreSeats: 'more-seats',
  move: 'move',
  myWaitingList: 'joined-waiting-lists',
  neutral: 'neutral',
  nodes: 'nodes',
  oauth: 'oauth',
  open: 'open',
  order: 'order',
  owners: 'owners',
  ownerships: 'ownerships',
  password: 'password',
  paymentInfo: 'payment-info',
  paymentSystems: 'payment-systems',
  personalInfos: 'personal-infos',
  phone: 'mobile-phone-number',
  pim: 'pim',
  position: 'position',
  positions: 'positions',
  preferences: 'fan/preferences',
  presence: 'presence',
  previewTicket: 'preview-ticket',
  previewVoucher: 'preview-voucher',
  price: 'price',
  profileImage: 'profile-image',
  properties: 'properties',
  publish: 'publish',
  question: 'question',
  questions: 'questions',
  registrationTypes: 'registration-types',
  remainingTickets: 'remaining-tickets',
  removals: 'removals',
  removeTickets: 'remove-tickets',
  reserve: 'reserve',
  reExportVoucher: 're-export-voucher',
  refreshToken: 'v2/authentication/refresh-token/',
  reject: 'reject',
  request: 'request',
  requests: 'requests',
  restore: 'restore',
  retry: 'retry',
  requestWithData: 'request-with-data',
  resetPassword: 'authentication/reset-password',
  revoke: 'revoke',
  // The employers on one fan group's Smart Invites roster, for the FGO merge screen.
  rosterEmployers: 'roster-employers',
  rotate: 'rotate',
  rsvpAttachment: 'rsvp-attachment',
  rsvpAttachmentUrl: 'rsvp-attachment-url',
  userRoles: 'user-roles',
  saml: 'saml',
  scan: 'scan',
  scanEvents: 'scan-events',
  scanner: 'scanner',
  schedule: 'schedule',
  scheduledDeletion: 'scheduled-deletion',
  search: 'search',
  searchEvent: 'search-event',
  sendTicketLink: 'send-ticket-link',
  seatCategories: 'seat-categories',
  seatersAdmin: 'seaters-admin',
  seats: 'seats',
  session: 'session',
  sessions: 'sessions',
  shuffle: 'shuffle',
  signup: 'v2/authentication/signup',
  // Java-owned Guest selection command. Deliberately NOT under `invitations/…`: that prefix is
  // allow-listed to Node at nginx/CloudFront and everything else falls through to Java, so
  // allow-listing it too would 404 this command. Pinned by smartInvites.routing.spec.ts.
  smartInviteSelections: 'v2/smart-invites',
  // `invitations` is a Node-owned prefix, already allow-listed at nginx and CloudFront; everything
  // not listed there defaults to Java. Nothing enforces at compile time that the backend controller
  // keeps this prefix, and a mismatch breaks in production only, which is what the routing spec pins.
  smartInvites: 'invitations/smart',
  stats: 'stats',
  surveys: 'surveys',
  systems: 'systems',
  // Node API admin taxonomy CRUD (fgo/taxonomy/*) — nginx routes fgo/* to Node.
  taxonomy: 'fgo/taxonomy',
  tc: 'tc',
  ticketing: 'ticketing',
  ticketPools: 'ticket-pools',
  tickets: 'active-waiting-lists-with-seat',
  timeZones: 'app/time-zones',
  transaction: 'transaction',
  translatedVenueConditions: 'translated-venue-conditions',
  translations: 'translations',
  tree: 'tree',
  unlink: 'unlink',
  unlock: 'unlock',
  unmarkForParkingDistribution: 'unmark-for-parking-distribution',
  updatePassword: 'v2/authentication/update-password',
  upload: 'upload',
  uploadProgress: 'upload-progress',
  uploadTickets: 'upload-tickets',
  users: `${seatersAdminPrefix}/users`,
  usersFGO: 'users',
  validate: 'validate',
  venueConditions: 'venue-conditions',
  venueConfigurations: `${seatersAdminPrefix}/venue-configurations`,
  venueImage: 'image',
  venues: `venues`,
  venuesSearch: 'search-venue',
  verify: 'verify',
  verifyOauth: 'verify-oauth',
  waitingListImage: 'waitinglist-image',
  waitingListNames: 'waiting-list-names',
  waitingLists: 'waiting-lists',
  duplicate: 'duplicate',
  waitingListsWithApprovals: 'waiting-lists-with-approvals',
  waitingListsWithInvitations: 'waiting-lists-with-invitations',
  waitingListsWithRequests: 'waiting-lists-with-requests',
  wlBadges: 'wl-badges',
  themes: 'themes',
  scheduleActivation: 'schedule-activation',
  scheduleArchiving: 'schedule-archiving',
  send: 'send',
  image: 'image',
  whatsappConfig: 'whatsapp/config',
  whatsappSenderNumber: 'sender-number',
  whatsappSenderNumbers: 'sender-numbers',
  whatsappTemplateOptions: 'template-options',
  whatsappTemplateOverrides: 'template-overrides',
  whatsappTemplates: 'whatsapp-templates',
};

// api / v2 / authentication / verify - oauth;
